import React, { useState, useEffect, useContext} from 'react';
import 'dayjs/locale/pt-br';
import dayjs, {Dayjs} from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';

import {
  TableCell,
  TableFooter,
  TableRow,
  makeStyles
} from "@material-ui/core";

// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
    TextField,
    Autocomplete
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
// component
import Loading from '../../components/Loading';
import Theme from '../../components/Button';

import {api, reiniciarToken, consultaDespesas, excluirDespesas, consultaTipoDespesas} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { fFormataDinheiro } from '../../utils/formatNumber';
import { fDateFormatCalendario, fDatePadrao } from '../../utils/formatTime';

export default function ConsultaDespesa() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  const [dataInicio, setDataInicio] = useState( dayjs() );
  const [dataFim, setDataFim] = useState( dayjs() );
  const [tipoDespesa, setTipoDespesa] = useState('');
  const [removeLoading, setRemoveLoading] = useState(false);
  const [tipoDespesas, setListTipoDespesas] = useState([]);
  let sumValorDespesa; 

  const getDespesas = async () => {
    setData([]);
    setRemoveLoading(false);
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaDespesas(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim), tipoDespesa);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      setRemoveLoading(true);
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_despesa: valores.id_despesa, 
                                     descricao: valores.descricao === '' ? valores.tipo_despesa.descricao : valores.descricao, 
                                     data_pagamento: fDatePadrao(valores.data_pagamento), 
                                     valor_pagamento: valores.valor_pagamento,
                                     valor_pagto_formatado: fFormataDinheiro(valores.valor_pagamento)}]);
      });
    }; 
  }

  const getListas = async () => {

    const response = await consultaTipoDespesas();

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setListTipoDespesas(tipoDespesas => [...tipoDespesas, {id_tipo_despesa: valores.id_tipo_despesa, descricao: valores.descricao}])
      }); 
    };
  }

  useEffect(() => {
    setData([]);
    getListas();
    getDespesas();
  },[]) 

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirDespesa = async (id) => {
    const response = await excluirDespesas(id);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getDespesas();
    }; 
  } 

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirDespesa(dados[dataIndex].id_despesa)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>

                            <MenuItem component={RouterLink} to={`/despesa/editar/${dados[dataIndex].id_despesa}`} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:edit-fill" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"id_despesa", label: "Código"} 
                  ,{name:"descricao", label: "Descrição"}
                  ,{name:"data_pagamento", label: "Data Pagamento"}
                  ,{name:"valor_pagto_formatado", label: "Valor do Pagamento"}
                  ];

  const useStyles = makeStyles((theme) => ({
    footerCell: {
        backgroundColor: "#cccccc",
        borderBottom: "none",
        color: "black",
        fontSize: 14,
        fontWeight: 'bold'
      }
  }));

  const classes  = useStyles();
  
  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
    customTableBodyFooterRender: (opts) => {
        
        sumValorDespesa = dados
          .reduce((total, item) => {
            return (total +  item.valor_pagamento);
        }, 0);

        return (
          <>
            {dados.length > 0 && (
              <TableFooter className={classes.footerCell}>
                <TableRow>
                  {opts.selectableRows !== 'none' ? <TableCell className={classes.footerCell} /> : null}
                  {opts.columns.map((col, index) => {
                    if (col.display === "true") {
                      if (col.name === "data_pagamento") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            TOTAL
                          </TableCell>
                        );
                      }if (col.name === "valor_pagto_formatado") {
                        return (
                          <TableCell key={index} className={classes.footerCell}>
                            {fFormataDinheiro(sumValorDespesa)}
                          </TableCell>
                        );
                      }  
                      if (col.name !== "data_pagamento" && col.name !== "valor_pagto_formatado") {
                        return <TableCell key={index} className={classes.footerCell}/>
                      };
                    }
                    return <TableCell key={index} className={classes.footerCell}/>;
                    })
                  }
                </TableRow>
              </TableFooter>
            )}
          </>
        );
    }
  };             
                    
  return (
    <Page title="Despesa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Despesa
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/despesa/cadastrar" startIcon={<Iconify icon="eva:plus-fill" />}>
              Nova Despesa
            </Button>
          </ThemeProvider>
        </Stack>
        <Stack mb={5} direction={{ xs: 'column', sm: 'row' }} alignItems="center" justifyContent="space-between" spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
            <DatePicker
              label="Data Inicial"
              value={dataInicio}
              onChange={(newValue) => {
                setDataInicio(newValue);
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
            <DatePicker
              label="Data Fim"
              value={dataFim}
              onChange={(newValue) => {
                setDataFim(newValue);
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
          </LocalizationProvider>
          <Autocomplete
                getOptionLabel={(resultado) => resultado.descricao}
                options={tipoDespesas}
                fullWidth
                onChange={(e, newValue) => {
                  setTipoDespesa(newValue?.id_tipo_despesa);
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Tipo Despesa" 
                                            fullWidth
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => option.id_tipo_despesa === value.id_tipo_despesa}                          
            />
          <ThemeProvider theme={Theme}>
            <Button fullWidth size="large" type="submit" variant="contained" color="neutral" onClick={getDespesas}>
              Consultar
            </Button>
          </ThemeProvider>
        </Stack>
        {!removeLoading && <Loading/>}
        {removeLoading && <Card>  
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <MUIDataTable
                data={Object.values(dados)}
                columns={columns}  
                options={options} 
            />
        </Card>}
      </Container>  
    </Page>  
  );
}

